import React, { useState, useEffect, useRef, use } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import './UserForm.css';
import { AddUser, UpdateUser } from "../store/adminThunks";
import uploadIcon from "../../../assets/upload.svg";
import { useDispatch, useSelector } from 'react-redux';
import {

  setError,
} from '../store/adminSlice'
import { useTranslation } from 'react-i18next';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { getMaps, getMapsByTenant } from '../../Map/store/MapDisplayThunks';
const UserForm = ({
  open,
  onClose,
  config,
  tenantId,
  selectedUser,
  onUserAdded,
  onUserUpdateded
}) => {

  const [formData, setFormData] = useState({
    userData: {
      tenant_id: tenantId,
      nom: "",
      prenom: "",
      email: "",
      password: "",
      urlphoto: "" ,
      map_access: []
    }
  });
  const dispatch = useDispatch();
   const {
       MapsMinimized
    } = useSelector((state) => state.MapDisplay);
useEffect(() => {
       dispatch(getMapsByTenant());
            }, [open]);

  useEffect(() => {
    if (selectedUser) {
const selectedMapIds = selectedUser.user_map_accesses 
      ? selectedUser.user_map_accesses.map((m) => m.map_id)
      : [];

      setFormData(prev => ({
        ...prev,
        userData: {
          ...prev.userData,
         map_access: selectedMapIds, 

        }
      }));

      setFormData(prev => ({
        ...prev,
        userData: {
          ...prev.userData,
          nom: selectedUser.lastName || '',
          prenom: selectedUser.firstName || '',
          email: selectedUser.email || '',
          urlphoto: selectedUser.urlphoto || '' ,
map_access: selectedMapIds,
        }
      }));

      setPreviewPhoto(selectedUser.urlphoto)
    } else {
      setFormData(prev => ({
        ...prev,
        userData: {
          ...prev.userData,
          nom: "",
          prenom: "",
          email: "",
map_access: [] // Initialize as an empty array for a new user
          
        }
      }));

      setPreviewPhoto(null)
    }
  }, [selectedUser]);

  const {t} = useTranslation();

  const [loading, setLoading] = useState(false);
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const fileInputRef = useRef();

  useEffect(() => { setPreviewPhoto(null) }, [])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      userData: {
        ...prev.userData,
        [name]: value,
      }
    }));
  };

  const handlePhotoDrop = (file) => {
    const url = URL.createObjectURL(file);
    setPreviewPhoto(url);

    setFormData(prev => ({
      ...prev,
      file: file
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) handlePhotoDrop(file);
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) handlePhotoDrop(file);
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setLoading(true);
    dispatch (setError(""));
    const formDataToUse = new FormData();

    if (selectedUser) {
      try {
        const email = selectedUser.email
        if (formData.file === undefined) {
          const data = {
            userData: formData.userData
          }
          formDataToUse.append('userData', JSON.stringify(data.userData));
          console.log("formDataToUse", data);


          const updatedUser = await dispatch(UpdateUser({ body: formDataToUse, params: [{ email }] }));
          onUserUpdateded(updatedUser);
        } else {
          const { urlphoto, ...userDataSansUrlPhoto } = formData.userData;
          const data = {
            file: formData.file,
            userData: userDataSansUrlPhoto
          }

          formDataToUse.append('file', data.file);
          formDataToUse.append('userData', JSON.stringify(data.userData));
          console.log("formDataToUse data", data);
          const updatedUser = await dispatch(UpdateUser({ body: formDataToUse, params: [{ email }] }));
          onUserUpdateded(updatedUser);
        }

        setPreviewPhoto(null);
        setFormData(prev => ({
          ...prev,
          userData: {
            ...prev.userData,
            nom: "",
            prenom: "",
            email: "",
            urlphoto: "",
            password: "",
            map_access: []
          }
        }));
        onClose()
      } catch (err) {
        console.error(err);
      } finally {
      }
    } else {
      try {

        if (formData.file) {
          formDataToUse.append('file', formData.file);
        }

        formDataToUse.append('userData', JSON.stringify(formData.userData));
        const addedUser = await dispatch(AddUser({ body: formDataToUse }));


        onUserAdded(addedUser.user , true );
        setPreviewPhoto(null);
        setFormData(prev => ({
          ...prev,
          userData: {
            ...prev.userData,
            nom: "",
            prenom: "",
            email: "",
            urlphoto: "",
            password: "",
           map_access:[]

          }
        }));
        onClose()
      } catch (err) {
        onUserAdded (err.data , false) ;
        onClose()

        console.error(err
          
        );
      } finally {
        setLoading(false);
      }
    }



  };

  return (
    <Dialog open={open} onClose={onClose} className="gestion-user-dialog">
      <DialogTitle className="gestion-user-dialog-title">
        <div className="title-dialog">
          <h2>
            {!selectedUser ?
              <>
                <span class="material-symbols-outlined">
                  person_add
                </span>
                {t("add_user")}
                  </> :
              <>
                <span class="material-symbols-outlined">
                  person_edit
                </span>
                {t("edit_user")}
              </>
            }
          </h2>

          <span className="material-symbols-outlined cursor-pointer" onClick={onClose}>
            close
          </span>
        </div>
        <Divider
          sx={{
            marginTop: "0.125rem",
            marginBottom: "0.8125rem",
            backgroundColor: "#CDD5DF",
          }}
        />
      </DialogTitle>

      <DialogContent>
          <form onSubmit={handleSubmit}>
          <div className='add-user-form'>
            <div>
              <label>{t("name")}:</label>
              <input
                type="text"
                name="nom"
                value={formData.userData.nom}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>{t("first_name")}:</label>
              <input
                type="text"
                name="prenom"
                value={formData.userData.prenom}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>{t("email_address")}:</label>
              <input
                type="email"
                name="email"
                value={formData.userData.email}
                onChange={handleChange}
                disabled={!!selectedUser}
                required

              />
            </div>

            <div className="form-group password-group">
              <label>{t("password")}:</label>
              <div className="password-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={formData.userData.password}
                  onChange={handleChange}
                  placeholder='**********'

                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShowPassword((prev) => !prev)}
                  tabIndex={-1}
                >
                  <span class="material-symbols-outlined">
                    {showPassword ? 'visibility_off' : 'visibility'}
                  </span>
                </button>
              </div>
            </div>
<div className="full">
  <label>{t("MAP_ACCESS")}:</label>
<Select
  multiple
  name="map_access"
  value={formData.userData.map_access || []}
  onChange={(e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      userData: {
        ...prev.userData,
        map_access: typeof value === 'string' ? value.split(',').map(id => parseInt(id)) : value,
      },
    }));
  }}
  displayEmpty
  renderValue={(selectedIds) => {
    if (selectedIds.length === 0) return t("select_maps");
    const selectedNames = MapsMinimized
      .filter((map) => selectedIds.includes(map.id))
      .map((map) => map.map_tenant.name);
    return selectedNames.join(', ');
  }}
  className="custom-select"
>
  {MapsMinimized.map((map) => (
    <MenuItem key={map.id} value={map.id}>
      {map.map_tenant.name}
    </MenuItem>
  ))}
</Select>

</div>




            <div
              className="photo-dropzone full"
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              {previewPhoto ? (
                <img src={previewPhoto} alt="Aperçu" className="photo-preview" />
              ) : (
                <>
                  <div className="photo-icon">
                    <img src={uploadIcon} />
                  </div>
                </>
              )}

              <p>{t("drag_and_drop")}</p>
              <p className='or'>{t("or")}</p>
              <button type="button" className="browse-button" onClick={() => fileInputRef.current.click()}>
                {t("browse_files")}
              </button>

              <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </div>
          </div>

          <div className='actions'>
            <button onClick={onClose} className='grey-btn'>
            {t("cancel")}
            </button>

   <button  type="submit"  className='primary-btn'>
            {selectedUser ? t("edit_user")   :  t("add_user")}
            </button>
          </div>
        </form> 
      </DialogContent>
    </Dialog>
  );
}

export default UserForm;
